import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f450aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-16 ant-col-xl-16" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Código Interno")
], -1))
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_6 = { class: "ss-produto-detalhes" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Descrição")
], -1))
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_10 = { class: "ss-produto-detalhes" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Unidade principal")
], -1))
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_14 = { class: "ss-produto-detalhes" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Marca")
], -1))
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_18 = { class: "ss-produto-detalhes" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Categoria")
], -1))
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_22 = { class: "ss-produto-detalhes" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "Tipo")
], -1))
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_26 = { class: "ss-produto-detalhes" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-detalhes ss-produto-detalhes-fundo-cinza" }, "NCM")
], -1))
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_30 = { class: "ss-produto-detalhes" }
const _hoisted_31 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_32 = {
  class: "ss-card-imagem",
  style: {"height":"190px","overflow-y":"auto"}
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"display":"block","margin-left":"auto","margin-right":"auto","margin-bottom":"-30px","margin-top":"-15px","width":"190px","height":"190px"},
      src: "/static/img/ilustracoes/nenhuma-novidade.svg"
    })
  ])
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-24",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"display":"block"} }, "Nenhuma imagem adicionada.")
  ])
], -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 2,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_44 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = {
  key: 3,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_52 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_54 = { class: "ant-row" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 2 }
const _hoisted_59 = {
  key: 4,
  class: "ss-table-apresentacao-mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_card = _resolveComponent("card")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.modalBase.computedVisivel)
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        keyboard: false,
        centered: "",
        width: "1000px",
        "wrap-class-name": _ctx.props.classeModal,
        visible: _ctx.modalBase.computedVisivel,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
        footer: null
      }, {
        title: _withCtx(() => [
          _createTextVNode("Detalhes do Produto")
        ]),
        closeIcon: _withCtx(() => [
          _createVNode(_component_icone, { nome: "voltar" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_skeleton, {
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, { layout: "horizontal" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_card, { titulo: "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.state.definicao.codigoInterno), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.state.definicao.produto), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.state.definicao.unidade), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.state.definicao.marca), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.state.definicao.categorias), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.state.definicao.tipoDescricao), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.state.definicao.ncm), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_card, {
                        titulo: "",
                        style: {"height":"205px"}
                      }, {
                        default: _withCtx(() => [
                          (_ctx.UtilitarioGeral.validaLista(_ctx.state.definicao.imagens))
                            ? (_openBlock(), _createBlock(_component_a_carousel, {
                                key: 0,
                                "dot-position": "top",
                                autoplay: "",
                                style: {"height":"190px","overflow":"scroll"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_32, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.definicao.imagens, (imagem) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: imagem.codigo,
                                        class: "ss-imagem"
                                      }, [
                                        _createVNode(_component_a_image, {
                                          src: imagem.imagem,
                                          height: 190,
                                          style: {"height":"190px!important"}
                                        }, null, 8, ["src"])
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_36))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.UtilitarioGeral.validaLista(_ctx.state.estoques))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_card, { titulo: "ESTOQUE E DISPONIBILIDADE" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_a_table, {
                                    columns: _ctx.state.colunasEstoques.filter(item => item.visible),
                                    "data-source": _ctx.state.estoques,
                                    rowKey: "codigo",
                                    pagination: false,
                                    size: "small",
                                    rowClassName: "ss-table-campos"
                                  }, {
                                    emptyText: _withCtx(() => [
                                      _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum estoque disponível" })
                                    ]),
                                    bodyCell: _withCtx(({ column, record }) => [
                                      (column.key === 'DescricaoEstoque')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(record.descricaoEstoque), 1))
                                        : (column.key === 'QtdDisponivel')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdDisponivel, 2)), 1))
                                          : (column.key === 'Detalhe')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                _createElementVNode("span", null, "Estoque: " + _toDisplayString(record.descricaoEstoque), 1),
                                                _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdDisponivel, 2)), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["columns", "data-source"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.UtilitarioGeral.validaLista(_ctx.state.definicao.codigos))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_card, { titulo: "CÓDIGOS E IDENTIFICAÇÃO" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _createVNode(_component_a_table, {
                                    columns: _ctx.state.colunasCodigos.filter(item => item.visible),
                                    "data-source": _ctx.state.definicao.codigos,
                                    rowKey: "tipo",
                                    pagination: false,
                                    size: "small",
                                    rowClassName: "ss-table-campos"
                                  }, {
                                    emptyText: _withCtx(() => [
                                      _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum código adicionado" })
                                    ]),
                                    bodyCell: _withCtx(({ column, record }) => [
                                      (column.key === 'TipoCodigo')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.obterDescricaoTipoCodigo(record.tipoCodigo)), 1))
                                        : _createCommentVNode("", true),
                                      (column.key === 'CodigoProduto')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(record.codigoProduto), 1))
                                        : _createCommentVNode("", true),
                                      (column.key === 'ValorItem')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(record.valorItem), 1))
                                        : (column.key === 'Detalhe')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                              _createElementVNode("span", null, "Tipo: " + _toDisplayString(_ctx.obterDescricaoTipoCodigo(record.tipo)), 1),
                                              _createElementVNode("span", null, "Codigo: " + _toDisplayString(record.codigo), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["columns", "data-source"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.UtilitarioGeral.validaLista(_ctx.state.caracteristicas))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_card, { titulo: "CARACTERÍSTICAS" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _createVNode(_component_a_table, {
                                    columns: _ctx.state.colunasCaracteristicas.filter(item => item.visible),
                                    "data-source": _ctx.state.caracteristicas,
                                    rowKey: "codigo",
                                    pagination: false,
                                    size: "small",
                                    rowClassName: "ss-table-campos"
                                  }, {
                                    emptyText: _withCtx(() => [
                                      _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhuma Características" })
                                    ]),
                                    bodyCell: _withCtx(({ column, record }) => [
                                      (column.key === 'Tipo')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.obterDescricaoTipoCaracteristica(record.tipo)), 1))
                                        : _createCommentVNode("", true),
                                      (column.key === 'Descricao')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(record.descricao), 1))
                                        : _createCommentVNode("", true),
                                      (column.key === 'Valor' && record.tipo !== _ctx.ETipoCaracteristica.Cor)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(record.valor), 1))
                                        : _createCommentVNode("", true),
                                      (column.key === 'Valor' && record.tipo === _ctx.ETipoCaracteristica.Cor)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 3,
                                            style: _normalizeStyle('background-color: ' + record.valor + '; color: ' + record.valor + ';')
                                          }, _toDisplayString(record.valor), 5))
                                        : (column.key === 'Detalhe')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                              _createElementVNode("span", null, "Tipo: " + _toDisplayString(_ctx.obterDescricaoTipoCaracteristica(record.tipo)), 1),
                                              _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                              _createElementVNode("span", null, "Valor: " + _toDisplayString(record.valor), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["columns", "data-source"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["wrap-class-name", "visible"]))
    : _createCommentVNode("", true)
}